module.exports = __webpack_public_path__ + "img/swiper6.4755eaf7.jpg";